import hqApi from './hqApiClient';

export interface HqFeature {
  key: string;
  name: string;
  category?: string;
}

export interface HqPlan {
  id: string;
  code: string;
  name: string;
  monthly_price: number;
  trial_days: number;
  alimtalk_unit_price: number;
  free_alimtalk_credits: number;
  is_active: boolean;
  display_order: number;
  features: string[];
}

export interface HqPlansResponse {
  catalog: HqFeature[];
  plans: HqPlan[];
}

export const hqPlanService = {
  async list(): Promise<HqPlansResponse> {
    const { data } = await hqApi.get<HqPlansResponse>('/api/v1/hq/plans');
    return data;
  },
  async update(id: string, payload: Partial<HqPlan>): Promise<void> {
    await hqApi.put(`/api/v1/hq/plans/${id}`, payload);
  },
  async create(payload: Partial<HqPlan>): Promise<void> {
    await hqApi.post('/api/v1/hq/plans', payload);
  },
};
